<template>
  <div :class="$style.countryBlockWrap">
    <client-only>
      <el-dialog
        :model-value="showCountryBlock"
        class="modal-dialog"
        :modal-append-to-body="true"
        :title="$t('kyc.notice')"
      >
        <div class="show-country-block-container">
          <div class="show-country-block-title">
            {{ $t('common.countryblock_tit__dear') }}
            <KycLimitCountry :country-list="countryBlockList" />
          </div>
          <div class="show-country-block-btn-container">
            <!-- <button class="btn show-country-block-btn show-country-block-btn-xs" @click="closeDialog">{{$t('common.countryblock_btn')}}</button> -->
          </div>
        </div>
      </el-dialog>
    </client-only>
  </div>
</template>

<script>
import { axiosClient } from '~/common/js/axios'
import { countryNameMap } from '~/common/js/country-name'
import { isLoginedToken } from '~/common/js/utils'
import KycLimitCountry from '~/components/kyc/KycLimitCountry.vue'
import get from 'lodash-es/get'
import { usePatchStore } from '@/common/js/patch'

export default {
  name: 'CounrtyBlockCompo',
  computed: {
    locale() {
      return this.store?.locale
    },
  },
  components: {
    KycLimitCountry,
  },
  data() {
    return {
      showCountryBlock: false,
      countryBlockList: [],
    }
  },
  mounted() {
    // 如果在登陆页，并且已登陆，不需要检查ip限制，因为还会跳转到交易页
    if (window.location.pathname.startsWith('/login/') && isLoginedToken()) {
      return
    }

    if (window.IP_BLOCKED === undefined) {
      this.requestBlocked()
    } else {
      this.showCountryBlock = window.IP_BLOCKED
    }
  },
  methods: {
    async getForbiddenIpCountry() {
      let countryList
      try {
        const res = await axiosClient({
          method: 'get',
          url: '/gw-api/user-center/settings/forbidden/ip/country',
        })
        if (res.success) {
          countryList = get(res, ['data', 'countryList'], [])
        } else {
          countryList = []
        }
      } catch (err) {
        // ignore
        countryList = []
      }
      return countryList
    },
    async requestBlocked() {
      const countryBlockList = await this.getForbiddenIpCountry()
      const AREA_BLOCK_LIST = ['Autonomous Republic of Crimea']
      try {
        const res = await axiosClient({
          method: 'get',
          url: '/gw-api/user-center/current-ip',
        })
        console.log('user-center/current-ip', res)
        if (res.success) {
          const { countryCode, ip, regionCode } = res.data
          // 优先级较低，kyc国家优先级高
          if (!window.currentCountryCode) {
            // 这个暂时只用来做隐藏币种的需求
            window.currentCountryCode = countryCode
            this.store.commit('trade/SET_PRIVATE_COIN_LIST')
          }
          let isBlock = false
          if (countryBlockList.includes(countryCode)) {
            isBlock = true
          }
          // 美国 纽约 禁止
          if (countryCode === 'US' && regionCode === 'NY') {
            isBlock = countryCode === 'US' && regionCode === 'NY'
          }
          if (AREA_BLOCK_LIST.includes(regionCode)) {
            isBlock = true
          }
          window.IP_BLOCKED = isBlock
          this.showCountryBlock = isBlock
          let limitCountries = []
          countryBlockList.forEach((code) => {
            const countryItem = countryNameMap[code]
            if (countryItem) {
              limitCountries.push(countryItem)
            }
          })
          this.countryBlockList = limitCountries
          this.store.commit('SET_IP', ip)
          if (countryCode && countryCode !== '') {
            this.store.commit('SET_COUNTRY_CODE', countryCode)
          }
        } else {
          console.log('check-ip failed!')
        }
      } catch (err) {
        console.log('check-ip failed!', err)
      }
    },
  },
  setup() {
    const { store } = usePatchStore()
    return {
      store
    }
  },
}
</script>
<style lang="less">
@import '../common/css/theme.less';
.modal-dialog {
  width: 90%;
  max-width: 720px;
  background-color: #fff;
  border-radius: 8px;
  margin-top: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  :global {
    .el-dialog__header {
      padding-top: 24px;
      padding-bottom: 8px;
    }
    .el-dialog__body {
      padding: 0 32px;
      padding-bottom: 32px;
    }
  }

  .show-country-block-title {
    font-size: 16px;
    line-height: 20px;
  }
  .show-country-block-container {
    text-align: left;
    .show-country-block-btn-container {
      // text-align:center;
    }
  }
  .el-dialog__header {
    .el-dialog__headerbtn {
      display: none;
    }
  }
}
.show-country-block-btn {
  background: @green_text1;
  color: @white_text1;
  border: 1px solid @green_text1;
  border-radius: 1px;
}
.show-country-block-btn:hover {
  color: @white_text1;
  opacity: 0.7;
}

@media (max-width: 768px) {
  .show-country-block-btn-xs {
    width: 80px;
  }
}
</style>

<style module lang="less">
.countryBlockWrap {
  :global {
    .el-dialog__header {
      padding: 32px 32px 8px 32px;
    }
    .el-dialog__body {
      padding: 0 32px;
      padding-bottom: 32px;
    }
  }
}
</style>
